import { render, staticRenderFns } from "./BroncosPlus.vue?vue&type=template&id=02797f69&scoped=true&"
import script from "./BroncosPlus.vue?vue&type=script&lang=js&"
export * from "./BroncosPlus.vue?vue&type=script&lang=js&"
import style0 from "./BroncosPlus.vue?vue&type=style&index=0&id=02797f69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02797f69",
  null
  
)

export default component.exports